import { RequestBaseService } from "@common/service/base-service/request";
import Message from "@common/ict/components/message";
import { ICT_APPLICATION_KEY } from "@common/ict/model/data";

const RequestService = new RequestBaseService();

RequestService.setRequestInterceptors(config => {
  config.headers["language"] = "zh-cn";
  config.headers["tenantKey"] = "1";
  config.headers["tenantId"] = "1";
  config.headers["application_key"] =
    ICT_APPLICATION_KEY || "1881ec8b-3d40-4d9e-9c33-77a8760fe618";
  // 部分接口不需要添加Authorization
  config.headers.noAuth && delete config.headers.Authorization;
  delete config.headers.noAuth;
  return config;
});
RequestService.setResponseInterceptors(function(response) {
  // Do something with response data
  const data = response.data;
  const isBlob = Object.prototype.toString.call(data) === "[object Blob]";
  if (!isBlob && !data.status) {
    Message.info(data.msg || "服务器开小差了");
    return Promise.reject(data);
  }
  return data;
});

const ICTRequestService = RequestService.axios;

const baseURL = process.env.VUE_APP_SERVER;

ICTRequestService.defaults.baseURL = baseURL;
export { ICTRequestService };
